
    import styled from 'styled-components';
    import * as Copy from 'styles/components/copy';
    import { Icon, Button, ButtonArrowIcon, ButtonLabel } from './pages/intro/components';

    const MenuItemElement = ({className, text, href, ...props}) =>
        <a className={ className } href={href}>
            <Icon />
            <div className={ 'title-body' }>
                <Copy.ParagraphElement className={ 'title-text' } text={ text } />
            </div>
        </a>

    const CloseSVG = ({ className, onClick, ...props }) =>
        <svg className={ className } viewBox="0 0 367 366" onClick={ onClick }>
            <title>Close</title>
            <polygon id="close" transform="translate(-1.000000, -78.000000)" stroke="none" fillRule="evenodd" fill="#000000" points="368 415 214 261 368 107 338 78 184 231 31 78 1 107 155 261 1 415 31 444 184 291 338 444"></polygon>
        </svg>

    export const Container = styled.div`
        display: flex;
        position: relative;
        padding: 20px 10px 40px;
        width: 100%;
        min-height: 80vh;
        height: auto;
        flex: 1 1 auto;
    `;

    export const Content = styled.div`
        display: flex;
        position: relative;

        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        height: auto;
        width: 100%;
        /* max-width: 960px; */
        max-width: 1100px;
        margin: 0 auto;

        transition: opacity 500ms;

        .menuOpen &
        {
            opacity: 0.4;
        }
    `;

    export const Logo = styled.img`
        pointer-events: none;
        object-fit: contain;
        object-position: center;
        max-width: 90px;
        width: 100%;
        height: auto;
        
        margin: 0 auto;

        ${({theme}) => theme.breakpoints['sm']}
        {
            max-width: 110px;
        }

        ${({theme}) => theme.breakpoints['md']}
        {
            max-width: 130px;
            margin: 0;
        }
    `;

    export const MenuContainer = styled.div`
        display: flex;
        position: fixed;
        visibility: hidden;
        justify-content: center;
        align-items: center;

        background: rgba(255, 255, 255, 0.5);
        height: 0vh;
        width: 100vw;
        left: 0;
        top: 0;

        padding: 52px 0;

        opacity: 0;
        z-index: 3;

        backdrop-filter: blur(0px);
        transition: opacity 500ms, backdrop-filter 500ms, visibility 0ms 500ms, height 0ms 500ms;
        
        .menuOpen &
        {
            visibility: visible;
            height: 100vh;
            opacity: 1;

            backdrop-filter: blur(2px);

            transition: opacity 500ms, backdrop-filter 500ms;
        }
    `;

    export const MenuWrapper = styled.div`
        display: flex;
        position: relative;
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
        max-width: 1100px;
        margin: 0 auto;
    `;

    export const MenuContent = styled.div`
        display: flex;
        position: relative;
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
        align-self: flex-end;
        padding: 0 0 0 10%;
        max-width: 600px;
    `;

    export const MenuItem = styled(MenuItemElement)`

        display: flex;
        cursor: pointer;
        position: relative;
        align-items: center;
        font-family: CNN Condensed;
        text-decoration: none;
        flex-direction: row;
        margin-bottom: 5px;

        transform: translate(50%, 0%);
        opacity: 0;
        
        transition: color 250ms, 
                    opacity 500ms ${({idx}) => idx * 100}ms, 
                    transform 500ms ${({idx}) => idx * 100}ms ease-out;

        .menuOpen &
        {
            transform: translate(0%, 0%);
            opacity: 1;
        }

        &.fitness { color: #ccaa00; }
        &.food { color: #e0003e; }
        &.sleep { color: #0791bc; }
        &.relationships { color: #71138f; }
        &.mindfulness { color: #85ac01; }
        &.greener { color: #5cb244; }
        
        &:hover
        {
            /* &.fitness { color: #ffdf25; }
            &.food { color: #ff3d7c; }
            &.sleep { color: #5cd7f8; }
            &.relationships { color: #b847ce; }
            &.mindfulness { color: #bbe223; } */
        }

        ${Icon}
        {
            width: 15px;
            height: 30px;
            margin-bottom: 0;
        }

        .title-body
        {
            display: flex;
            position: relative;
            flex-direction: row;
            align-items: center;
            padding: 0 40px 0 10px;
        }

        .title-text
        {
            letter-spacing: 1.25px;
            font-size: 30px;
            font-weight: 800;
            margin: 0;
        }

        ${({theme}) => theme.breakpoints['sm']}
        {
            margin-bottom: 10px;

            ${Icon}
            {
                width: 20px;
                height: 40px;
            }
            
            .title-text
            {
                font-size: 40px;
            }
        }

        ${({theme}) => theme.breakpoints['md']}
        {
            .title-text
            {
                font-size: 50px;
            }
        }
    `;

    export const MenuStart = styled.div`
        margin-top: 20px;
        max-width: 400px;
        padding-right: 30px;

        ${({theme}) => theme.breakpoints['sm']}
        {
            margin-top: 40px;
        }
    `;

    export const CloseBtn = styled(CloseSVG)`
        cursor: pointer;
        box-sizing: content-box;
        display: flex;
        position: absolute;
        border: 2px solid black;
        border-radius: 50%;
        padding: 8px;
        justify-content: center;
        align-items: center;
        height: 20px;
        width: 20px;
        right: 15px;
        transform: translate(0, -110%);
    `;

    export { Button, ButtonArrowIcon, ButtonLabel };
